/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React, { useRef } from "react"
import TopHeader from "../../components/TopHeader"
import { useSelector,useDispatch } from "react-redux"
import { useEffect,useCallback,useContext ,useState} from "react"
import { useLocation,useSearchParams } from "react-router-dom"
import Debounce from "../../CommonMethods/Debounce"
import { limitReducer, resetArrays } from "../../redux/MultiselectRows"
import Table from "./Components/Table"
import Pagination from "../../components/Pagination"
import Limit from "../../components/Limit"
import GlobalContext from "../../components/Context/GloablContext"
import CustomOverLay from "../../components/CustomOverLay"
import SearchEmptyScreen from "../../components/SearchEmptyScreen"
import Emptyscreen from "../../components/EmptyScreen"
import moment from "moment"
import { convertDatesToEpochUTC } from "../../CommonMethods/ConvertFilterDatetoEpochUtcFormat"
import TopBarActivityHistory from "./Components/Topbar"
import { useExportConsilatedActivityHistoryListMutation, useGetActivityHistoryListQuery } from "../../features/activityHistorySlice"
import Emptyscreenwithouttitle from "../../components/Emptyscreenwithouttitle"

export default function ManageActivityHistory(){
    const {setToastmessage,Toastmessage,toastErrorMessage,setToastErrorMessage,isSideBar} = useContext(GlobalContext);
    const [exportActivityHistory]=useExportConsilatedActivityHistoryListMutation()
    const [suggestions,setSuggestions]=useState("")
    const [limit,setLimit]=useState("15")
    const [skip,setSkip]=useState(true)
    const [isColumnSelect,setIsColumnSelect] = useState(false)
    const location=useLocation()
    const locationStateProcessed = useRef(false)
    const dispatch=useDispatch()
    const [searchParams, setSearchParams] = useSearchParams({});
    const [isSortselected,setisSortSelected]=useState(false)
    
    const auth=useSelector(state=>state?.auth)

    const [selectedOrganizationName, setSelectedOrganizationName] = useState([{
        organization_name: '',
        organization_id: '',
    }]);
    const [subDivisionDataLoading,setSubDivisionDataLoading]= useState(false)
    const userArr=useSelector(state=>state?.subdivSelect?.subdivData?.checkedArr)

    const initialState={
        "user_name":'',
        'field':'',
        'target':'',
        'user_type':'',
        "action":'',
    }
    const [filterValues,setFilterValues]=useState(initialState)

    const initialDateState = {
        "start_date":searchParams?.get('start_date')?`${new Date(parseInt(searchParams?.get('start_date'))*1000).getFullYear()}-${String(new Date(parseInt(searchParams?.get('start_date'))*1000).getMonth() + 1).padStart(2, '0')}-${String(new Date(parseInt(searchParams?.get('start_date'))*1000).getDate()).padStart(2, '0')}`:new Date(),
        "end_date":searchParams?.get('end_date')?`${new Date(parseInt(searchParams?.get('start_date'))*1000).getFullYear()}-${String(new Date(parseInt(searchParams?.get('end_date'))*1000).getMonth() + 1).padStart(2, '0')}-${String(new Date(parseInt(searchParams?.get('end_date'))*1000).getDate()).padStart(2, '0')}`:new Date(),
        
    }
    const [filterDateValues,setFilterDateValues]=useState(initialDateState)

    useEffect(() => {
        const start_date = searchParams.get('start_date')
        const end_date = searchParams.get('end_date')
        if (start_date || end_date) {
            setFilterDateValues((prev) => {
                const next = {...prev}
                if (start_date) {
                    const d = new Date(parseInt(start_date) * 1000)
                    next.start_date = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`
                }
                if (end_date) {
                    const d = new Date(parseInt(end_date) * 1000)
                    next.end_date = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`
                }
                return next
            })
        }
    }, [searchParams])

    const {data,isFetching,isLoading,status}=useGetActivityHistoryListQuery(searchParams?.toString(),{skip: skip||location.search===''})
    /**
     * The function `handleSearchParams` updates the search parameters by setting the value of a
     * specific key and value, and then updating the search parameters state.
     */
    const handleSearchParams = (key, value) => {
        let params = Object.fromEntries(searchParams);

        // Only reset page_number to 1 if we're not explicitly setting page_number
        if (key !== 'page_number') {
            params.page_number = 1
            params.last_page = null
            params.last_id = null
        }

        if(key === 'search') {params[key] = encodeURIComponent(value); }
        else params[key] = value
        if (params.search === '') delete params.search
        setSearchParams({ ...params})
    }

    

    useEffect(() => {
        if(location.search===''){
            setSkip(true)
        }
        if(location.state!==null&&location.state!==''&& !Array.isArray(location.state) && !locationStateProcessed.current){
            locationStateProcessed.current = true
            let params = {...location.state};
            if(location.state.search && location.state.search !== ''){
                params.search = decodeURIComponent(location.state.search)
            }
            setSearchParams({...params})
            return
        }
        
        if(!locationStateProcessed.current && searchParams.size === 0){
            if(!searchParams.get('limit')){
                handleSearchParams('limit','15')
            }
            if(!searchParams.get('page_number')) { 
                handleSearchParams('page_number', '1')
            }
            if(!searchParams.get('start_date')) { 
                handleSearchParams('start_date', convertDatesToEpochUTC(moment(filterDateValues?.start_date).format('YYYY-MM-DD'),Intl.DateTimeFormat().resolvedOptions().timeZone,true))
            }
            if(!searchParams.get('end_date')) { 
                handleSearchParams('end_date', convertDatesToEpochUTC(moment(filterDateValues?.end_date).format('YYYY-MM-DD'),Intl.DateTimeFormat().resolvedOptions().timeZone,false))
            }
            if(!searchParams.get('filter')) {
                handleSearchParams('filter', `true`)
            }
        }
        
        setSuggestions(!searchParams.get('search') ? '' : decodeURIComponent(searchParams.get('search')) || '')
        
    }, [location]);


    useEffect(()=>{
        if(searchParams.size>=7){
            setSkip(false)
        }
        else{
            setSkip(true)
        }
    },[searchParams])

    const handleApplyFilter = (type) => {
        let params = Object.fromEntries(searchParams);
        params.page_number = 1;
        params.last_page = null
        params.last_id = null
        if (type) {
            if (filterValues?.user_name?.trim() !== '') {
                params.user_name = filterValues?.user_name?.trim();
            } else {
                delete params.user_name;
            }
            if (filterValues?.field?.trim() !== '') {
                params.field = filterValues?.field?.trim();
            } else {
                delete params.field;
            }
            if (filterValues?.target?.trim() !== '') {
                params.target = filterValues?.target?.trim();
            } else {
                delete params.target;
            }
            if (filterValues?.user_type?.trim() !== '') {
                params.user_type = filterValues?.user_type?.trim();
            } else {
                delete params.user_type;
            }
            if (filterValues?.action !== '') {
                params.action = filterValues?.action;
            } else {
                delete params.action;
            }
    
            setSearchParams({ ...params });
    
        } else {
            // Clear filterValues when type is false
    
            setFilterValues(  {
                "user_name":'',
                'field':'',
                'target':'',
                'user_type':'',
                "action":'',
            });
    
            delete params.user_name;
            delete params.field;
            delete params.target;
            delete params.user_type;
            delete params.action;
   
            setSearchParams({ ...params });
        }
    };
    
   
    function handleNoOfRowsClick(number) {
        let params = Object.fromEntries(searchParams);  
        params.page_number = 1;
        params.last_page= null
        params["limit"] = number;
        params['last_id']=null
        params['last_page'] =null
        setSearchParams({ ...params });

    }
    const handleOnClickPageNumber = (pageNum) => {
        setisSortSelected(false)
        const params = Object.fromEntries(searchParams)
        setSearchParams({ ...params, page_number: pageNum,last_id:(pageNum===1?null:searchParams?.get('page_number')>pageNum?(data?.data?.[0]?._id!==undefined?data?.data[0]?._id:null):(data?.data?.[data?.data?.length-1]?._id!==undefined?data?.data[data?.data?.length-1]?._id:null)),last_page:(pageNum===1?null:searchParams?.get('page_number')>pageNum?searchParams?.get('page_number'):searchParams?.get('page_number')) })
       
    }

    useEffect(() => {
        if(data!==undefined){
            dispatch(limitReducer([data,searchParams.get("limit"),searchParams.get("page_number")]))
        }
    }, [data?.data]);

    const handleChange = (val) => {
        handleSearchParams('search', val)
        
    };

    const optimizedFn = useCallback(
        Debounce((value) => handleChange(value)),
        [searchParams]
    );

    
    const handleDispatch = useCallback(() => {
        // Don't override if location.state has been processed
        if (locationStateProcessed.current) return;
        
        if (!searchParams.get('limit')) {
            handleSearchParams('limit', '15');
        }
        if (!searchParams.get('page_number')) {
            handleSearchParams('page_number', '1');
        }
        if (!searchParams.get('last_id')) {
            data===undefined?handleSearchParams('last_id', null):handleSearchParams('last_id', data?.data?.[data?.data?.length-1]?._id);
        }
        if (!searchParams.get('last_page')) {
            handleSearchParams('last_page', null)
        }
        if(!searchParams.get('start_date')) { 
            handleSearchParams('start_date', convertDatesToEpochUTC(moment(filterDateValues?.start_date).format('YYYY-MM-DD'),Intl.DateTimeFormat().resolvedOptions().timeZone,true))
        }
        if(!searchParams.get('end_date')) { 
            handleSearchParams('end_date', convertDatesToEpochUTC(moment(filterDateValues?.end_date).format('YYYY-MM-DD'),Intl.DateTimeFormat().resolvedOptions().timeZone,false))
        }
        if(!searchParams.get('filter')) {
            handleSearchParams('filter', `true`)
        }
        
        
    }, [location]);

    useEffect(() => {
        handleDispatch()
        
    }, [handleDispatch]);


    return(
        <>
            <div className='bg-[#F9F3F5] pt-[95px] px-[30px] h-full w-full overflow-x-hidden'>
                <TopHeader title={"Activity History"}/>
                <div className='bg-white rounded-lg pt-3 h-customh3 relative'>
                    <div className="px-6">
                        <TopBarActivityHistory 
                            title={'List of Activity History'}
                            AddButton={true}
                            SearchInput={((data?.data?.length===0 &&searchParams.get("search")===null) ||data===undefined) ? false : true}
                            ApplyFilter={true}
                            suggestions={suggestions}
                            setSuggestions={setSuggestions}
                            optimizedFn={optimizedFn}
                            data={data}
                            exportCols={['Timestamp','Username','Fields','Old Value','New Value','PHI Exposed','Target Username','Target Type','Action Performed','More Info']}
                            isColumnSelect={isColumnSelect}
                            setIsColumnSelect={setIsColumnSelect}
                            exportActivityHistory={exportActivityHistory}
                            filterValues={filterValues}
                            setFilterValues={setFilterValues}
                            filterDateValues={filterDateValues}
                            setFilterDateValues={setFilterDateValues}
                            handleApplyFilter={handleApplyFilter}
                            selectedOrganizationName={selectedOrganizationName}
                            setSelectedOrganizationName={setSelectedOrganizationName}
                            setSubDivisionDataLoading={setSubDivisionDataLoading}
                            userArr={userArr}
                            subDivisionDataLoading={subDivisionDataLoading}
                            TotalCount={parseInt(data?.total_count)}

                        />
                    </div>
                    {((isFetching&&status!=="fulfilled"&&status!=="rejected"&&!isSortselected)||(isLoading)||(data===undefined&&status!=="fulfilled"&&status!=="rejected"))?<CustomOverLay Active text="Loading Activity History list..." classKey={`absolute top-0 left-0 right-0  z-50 overflow-hidden bg-gray-400 opacity-75 flex flex-col items-center justify-center  ${isSideBar?'opened_sidebar_overlay-activity':'overlay-list-activity'}`}/>: (data!==undefined && data?.data?.length > 0 ) ? <>
                        <div className="px-6">
                            <Table
                                pageNumber={Number(searchParams.get('page_number')) || 1}
                                List={data}
                                handleSearchParams={handleSearchParams}
                                sortValue={searchParams.get('sort') || ''}
                                setisSortSelected={setisSortSelected}
                            />
                        </div>
                        {data?.total_count>=15 &&<div className="w-[100%] px-2.5 py-1 flex items-center justify-between bg-[#F4F7FC] rounded-b-[8px]">
                            <p className="text-sm font-semibold text-[#687182]">Total Number of Records:{Math.ceil(parseInt(data?.total_count))}</p>
                            <div className="flex items-center">
                                <Limit
                                    limit={limit}
                                    setLimit={setLimit}
                                    handleNoOfRowsClick={handleNoOfRowsClick}
                                    isColumnSelect={isColumnSelect}
                                />
                        
                                <Pagination
                                    TotalCount={parseInt(data?.total_count)}
                                    totalPageNumber={Math.ceil(parseInt(data?.total_count)/parseInt(searchParams?.get("limit")))}
                                    handleOnClickPageNumber={handleOnClickPageNumber}
                                    // limit={Number(searchParams.get('limit'))}
                                    limit={parseInt(limit)}
                                />
                            </div>
                        </div>}
                    </>:<>
                        {(data?.total_count===0 &&suggestions?.trim()!=="")||(data?.success_status==="false")||(searchParams.get('user_name')!==null||searchParams.get('field')!==null||searchParams.get('action')!==null||searchParams.get('target')!==null||searchParams.get('action')!==null) ?
                            <SearchEmptyScreen text={"That filter combination has no result. Please try different criteria"} />
                            :
                            data?.total_count===0&&!searchParams.get("search")?<Emptyscreenwithouttitle
                                FirstPTag={"No activity history to view yet"}
                            />:((status==="rejected"||(data?.total_count!==0&&data?.data?.length===0))&&<SearchEmptyScreen text={"No data found"} />)
                        }
                    </>}
                </div>
            </div>
        </>
   
    )
}


